// extracted by mini-css-extract-plugin
export default {"modalContent":"OfferModal_modalContent__fTd9-"};